import { useStyles } from './styles'

type CoinIconProps = {
  classes?: Record<string, string>
}
export const CoinIcon = (props: CoinIconProps) => {
  const { classes } = useStyles({ classesOverrides: props.classes })
  return (
    <div className={classes.root}>
      <img
        src="/assets/svg/coinImage.svg"
        alt=""
      />
    </div>
  )
}
